import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { toast } from "sonner";
import { MailCheck } from "lucide-react";
import api, { formatApiError } from "../lib/api";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Button } from "../components/ui/button";

export default function ForgotPassword() {
  const location = useLocation();
  const [email, setEmail] = useState(location.state?.email || "");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try { await api.post("/auth/forgot-password", { email }); setSent(true); }
    catch (err) { toast.error(formatApiError(err.response?.data?.detail) || "Errore, riprova"); }
    finally { setLoading(false); }
  };
  return (
    <div className="mx-auto max-w-md px-4 py-16">
      <div className="ga-card p-8" data-testid="forgot-card">
        <div className="text-xs font-mono uppercase tracking-widest text-slate-500">Recupero accesso</div>
        <h1 className="mt-1 font-display text-3xl font-extrabold text-slate-900">Password dimenticata</h1>
        {sent ? (
          <div className="mt-6 rounded-xl bg-emerald-50 border border-emerald-200 p-4 text-sm text-emerald-900 flex gap-3" data-testid="forgot-sent">
            <MailCheck className="w-5 h-5 shrink-0" />
            <div>Se <b>{email}</b> è registrato, riceverai entro pochi minuti un'email con il link per scegliere una nuova password (valido 60 minuti). Controlla anche la cartella spam.</div>
          </div>
        ) : (
          <form onSubmit={submit} className="mt-6 space-y-4">
            <p className="text-sm text-slate-600">Inserisci l'email del tuo account acquirente o fornitore: ti invieremo un link per reimpostare la password.</p>
            <div>
              <Label htmlFor="email">Email</Label>
              <Input id="email" type="email" required value={email} onChange={e => setEmail(e.target.value)} data-testid="forgot-email-input" autoComplete="email" />
            </div>
            <Button type="submit" disabled={loading} className="w-full ga-btn-primary rounded-full" data-testid="forgot-submit-button">{loading ? "Invio..." : "Invia link di reset"}</Button>
          </form>
        )}
        <p className="mt-6 text-sm text-slate-600"><Link to="/login" className="font-semibold text-slate-900 hover:underline" data-testid="forgot-to-login-link">← Torna al login</Link></p>
      </div>
    </div>
  );
}
